import { render, staticRenderFns } from "./teacherEvaluation.vue?vue&type=template&id=639c6c50"
import script from "./teacherEvaluation.vue?vue&type=script&lang=js"
export * from "./teacherEvaluation.vue?vue&type=script&lang=js"
import style0 from "./teacherEvaluation.vue?vue&type=style&index=0&id=639c6c50&prod&lang=scss&rel=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports